<template>
  <div class="container offset-md-3 col-md-6 pt-5 pb-5">
    <div v-if="!success">

      <div class="header text-center">
        <h1 class="title"><img src="../../../img/logo.png"/></h1>
        <h2 >アカウントを作成しましょう</h2>
      </div>
      
      <div class="plan mb-2">
        プラン: 
        <span v-if="plan==='standard'">
          スタンダード
          <button type="button" class="btn btn-sm btn-outline-secondary" @click="plan='free'">無料トライアルはこちら</button>
        </span>
        <span v-else>
          無料トライアル(ユーザ制限1人)
          <button type="button" class="btn btn-sm btn-outline-primary" @click="plan='standard'">スタンダードプランはこちら</button>
        </span>
      </div>

      <form @submit.prevent="createToken()">
        <div class="form-group">
          <input type="text" class="form-control" @focus="onFocus='company'" @blur="onFocus=''" placeholder="組織名 (例: アスニピース株式会社)" v-model="postData.companyName" required>
          <label v-if="onFocus==='company' && postData.companyName" for="company-name">組織名</label>
          <label v-if="onFocus!=='company' && postData.companyName" class="text-success ml-2"><i class="fas fa-check"></i></label>
        </div>
        <div class="form-group">
          <input type="text" class="form-control" @focus="onFocus='name'" @blur="onFocus=''" placeholder="あなたの氏名" v-model="postData.userName" required>
          <label v-if="onFocus==='name' && postData.userName">あなたの氏名</label>
          <label v-if="onFocus!=='name' && postData.userName" class="text-success ml-2"><i class="fas fa-check"></i></label>
        </div>
        <div class="form-group">
          <input type="mail" class="form-control" :class="{'border-danger': invalidMail || alreadyMail || invalidDomain}" @focus="onFocus='mail'" @blur="onFocus=''" placeholder="メールアドレス" v-model="postData.mail" @change="checkMailExists" required>
          <label v-if="onFocus==='mail' && postData.mail" for="admin-mail">メールアドレス</label>
          <label v-if="onFocus!=='mail' && postData.mail && !alreadyMail && !invalidDomain && !invalidMail" class="text-success ml-2"><i class="fas fa-check"></i></label>
          <span class="text-danger" v-if="invalidMail">正しいメールアドレスを入力ください</span>
          <span class="text-danger" v-if="alreadyMail || invalidDomain">既に登録されているドメインです</span>
        </div>
        <div v-if="plan==='standard'" class="form-group">
          <card class='stripe-card form-control'
            :class='{ complete }'
            stripe='pk_test_ATB0BR6wa6qxRztqsPZbSzrH'
            :options='stripeOptions'
            @change='complete = $event.complete'
          />
        </div>
        <div style="text-align: center;">
          <input v-if="plan==='standard'" type="submit" class="btn btn-primary" value="スタンダードプランの開始" :disabled='!complete || (alreadyMail || invalidDomain)'/>
          <input v-else type="submit" class="btn btn-primary" value="無料で試す" :disabled=' !postData.companyName || !postData.userName || !postData.mail || (alreadyMail || invalidDomain)'/>
        </div>
      </form>
      <router-link :to="'/login'">ログインページはこちら</router-link>
    </div>
    <div v-else>
      登録されたメールアドレス宛にパスワードを送信しました。
      <router-link :to="'/login'">ログインページはこちら</router-link>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.header {
  margin: 0 auto;
  .title {
    height: 63px;
  }
  h2 {
    font-size: 1rem;
    font-weight: bold;
  }
}
form {
  padding: 10px;
  background: snow;
  input[type='submit']{
    border: none;
    background: #C91609 !important;
    font-size: 1.25rem;
  }
  .form-group {
    position: relative;
    label {
      position: absolute;
      top: 30%;
      right: 10px;
      color: #6a6a6a;
    }
  }
}
.stripe-card {
  width: 300px;
  border: 1px solid grey;
}
.stripe-card.complete {
  border-color: green;
}
</style>

<script>
import CommonAPI from '../../api/common-api'
import CompanyAPI from '../../api/company-api'
import UserAPI from '../../api/user-api'
import Modal from '../Modal.vue'
import { Card, createToken } from 'vue-stripe-elements-plus'

export default {
  name: "sign-up",
  components: {
    Card,
    Modal
  },
  data() {
    return {
      plan: 'standard',
      onFocus: null,
      invalidDomain: false,
      invalidMail: false,
      alreadyMail: false,
      success: false,
      postData: {
        domain: null,
        companyName: null,
        userName: null,
        mail: null,
        password: null
      },
      complete: false,
      stripeOptions: {},
    }
  },
  watch: {
    //===============================================
    // メールアドレス変更時のチェック
    //===============================================
    'postData.mail': function (val) {
      if(val != null && val.indexOf('@') >= 0) {
        const split = val.split('@')
        this.postData.domain = split[split.length - 1]
      } else {
        this.postData.domain = null
        this.invalidDomain = false
      }
    }
  },
  mounted () {
    this.$root.$refs.loading.$data.show = false
  },
  methods: {
    //===============================================
    // ドメインの既存チェック
    //===============================================
    async checkDomainExists () {
      const res = await CompanyAPI.isExists(this.postData.domain)
      this.invalidDomain = res.isExists
    },
    //===============================================
    // メール重複チェック
    //===============================================
    async checkMailExists () {
      // 形式チェック
      const exp = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
      if (!this.postData.mail.match(exp)){
        this.invalidMail = true
        return false
      } else {
        this.invalidMail = false
      }
      // 重複チェック
      const body = {
        mail: this.postData.mail
      }
      const res = await UserAPI.isExists(body)
      this.alreadyMail = res.isExists
    },
    //===============================================
    // サインアップ
    //===============================================
    async signUp () {
      // 既存チェック。早押しでチェックを通り抜けるため、API成功まで待機
      const body = {
        mail: this.postData.mail
      }
      try{
        const mailRes = await UserAPI.isExists(body)
        const domainRes = await CompanyAPI.isExists(this.postData.domain)
        this.alreadyMail = mailRes.isExists
        this.invalidDomain = domainRes.isExists

        if (this.alreadyMail || this.invalidDomain) {
          this.$root.$refs.loading.$data.show = false
          return false // 重複はFlase
        } else {
          CommonAPI.signUp(this.postData)
            .then(res => {
              this.success = true
              this.$root.$refs.loading.$data.show = false
            })
        }
      } catch(err) {
        this.$root.$refs.loading.$data.show = false
      }
    },
    //===============================================
    // トークン取得
    //===============================================
    createToken () {
      this.$root.$refs.loading.$data.show = true
      if(this.plan === 'free') {
        this.signUp()
      } else {
        createToken()
          .then(function (data){
            this.postData.token = data.token.id
            this.signUp()
          }.bind(this))
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/assets/js/components/common/SignUp.vue